import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from 'app/components/mat-custom-table/tableColumn';
import { ParametrosService } from 'app/services/parametros.service';
import { take } from 'rxjs';
import { Parametro, Notificacion, DetalleFolio } from 'app/models/parametro.model';

export interface PeriodicElement {
    id: string;
    fechaingreso: Date;
    folioInicial: string;
    folioFinal: string;
    total: number;
    fechaVencimiento: Date;
    estado: string;
}

export interface IFOLIOS {
    folio: string;
    estado: string;
    fecha: Date;
}

@Component({
    selector: 'detalle',
    templateUrl: './detalle.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./detalle.component.scss'],
})
export class DetalleFolioComponent {
    constructor(private route: Router, private actvatedRoute: ActivatedRoute, private _ParametrosService: ParametrosService) {}
    ID = this.actvatedRoute.snapshot.params.ID;
    ngOnInit(): void {
        console.log(this.ID);
        this._ParametrosService
            .getDetalleFolio(this.ID)
            .pipe(take(1))
            .subscribe({
                next: (folio) => {
                    this.dataSourceFolios = folio;
                    //buscamos los folios Disponibles y anulados
                    folio.reduce((acc, item) => {
                        if (item.ID_ESTADO == 2) {
                            this.foliosDisponibles = this.foliosDisponibles + 1;
                        }
                        if (item.ID_ESTADO == 4) {
                            this.foliosAnulados = this.foliosAnulados + 1;
                        }
                        return acc;
                    }, {});
                    //buscamos el folio inicial
                    this.folioMaximo = Math.max.apply(
                        Math,
                        folio.map(function (o) {
                            return o.FOLIO;
                        })
                    );
                    //buscamos el folio final
                    this.folioMinimo = Math.min.apply(
                        Math,
                        folio.map(function (o) {
                            return o.FOLIO;
                        })
                    );
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {},
            });
    }

    goback(): void {
        this.route.navigateByUrl('home/sistema/folios');
    }

    columnsFolios: TableColumn[] = [
        {
            columnDef: 'FOLIO',
            header: 'FOLIO',
            headerClass: 'text-center px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center ',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'ID_ESTADO',
            header: 'ESTADO',
            headerClass: 'text-center px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'flex items-center gap-2',
            columnType: 'custom',
            columnFormat: '',
            columnSort: true,
            columFunction: this.printEstadoFolios,
        },
        {
            columnDef: 'FECHA_ACTUALIZACION',
            header: 'FECHA INGRESO',
            headerClass: 'text-center px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-center',
            columnClassMobile: 'paragraph-4',
            columnType: 'date',
            columnFormat: 'dd/MM/YYYY',
            columnSort: true,
        },
    ];
    foliosDisponibles: number = 0;
    foliosAnulados: number = 0;
    folioMinimo: number = 0;
    folioMaximo: number = 0;
    selection = new SelectionModel<any>(true, []);

    dataSourceFolios = [];

    onTableAction(row: any) {
        console.log('ver detalles de', row);
    }

    printEstadoFolios(row: any, attribute: string): string {
        let dict = {
            2: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-04">
                    <p class="paragraph-tag_upper text-primary-green-01">
                    DISPONIBLE
                    </p>
                </div>
            </div>`,
            4: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-pink-01">
                    <p class="paragraph-tag_upper text-primary">
                    ANULADO
                    </p>
                </div>
            </div>`,
            3: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-gray-02">
                    <p class="paragraph-tag_upper text-primary-gray-01">
                    UTILIZADO
                    </p>
                </div>
            </div>`,
        };
        return dict[row[attribute]] || '';
    }

    printEstadoFoliosMobile(attribute: string): string {
        let dict = {
            DISPONIBLE: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-04">
                    <p class="paragraph-tag_upper text-primary-green-01">
                    DISPONIBLE
                    </p>
                </div>
            </div>`,
            ANULADO: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-pink-01">
                    <p class="paragraph-tag_upper text-primary">
                    ANULADO
                    </p>
                </div>
            </div>`,
            UTILIZADO: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-gray-02">
                    <p class="paragraph-tag_upper text-primary-gray-01">
                    UTILIZADO
                    </p>
                </div>
            </div>`,
        };
        return dict[attribute] || '';
    }
}
